import {Map} from 'immutable';
import {GMI} from '../constants/index';
import {casteImmutable} from '../utils/redux';

/**
 * General action handling for reservation initiate state updates
 * @param {Object} state An immutable state object to check against
 * @param {Object} action Data to update the redux store state
 * @returns {Object} A (usually changed) immutable state object
 */
export default function (state = Map(), action = null) {
  switch (action.type) {
    case GMI.DELETE_GMI_STATE:
      return state.deleteIn(action.path);

    case GMI.SET_GMI_STATE:
      return state.setIn(action.path, casteImmutable(action.value));

    case GMI.UPDATE_GMI_STATE_LIST_BY_UID: {
      /**
       * Reducer for editing a state list of objects using finds by a uid
       *  action.path - path to the list
       *  action.value - should be an object with set of desired changes to list item
       *  action.uid - value of expected uid property to identify item to update
       *  action.uidKey - custom uidKey can be set, otherwise defaults to searching for 'uid' property
       *  action.createNew - pushes new item if uid is not found, defaults to true
       *  action.replace - if set to true, replaces item with value object, otherwise defaults to merging value object
       */
      const {path, value, uid, uidKey = "uid", createNew = true, replace} = action;
      const list = state.getIn(path);
      const index = list.findIndex( item => item.get(uidKey) === uid );
      let newList = list;
      if(index === -1 && createNew) {
        newList = list.push(casteImmutable(value));
      } else {
        newList = list.update(
          index,
          item => replace ? casteImmutable(value) : item.merge(value)
        );
      }
      return state.setIn(path, casteImmutable(newList));
    }

    default:
      return state;
  }
}
